// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.createGpsTrackerModal__xGNA_ {
  width: 372px;
  height: 532px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.modalBody__Papqc {
  padding: 25px 51px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.modalBodyTitle__kzIJj {
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.25px;
  color: var(--header-title-main);
  margin-bottom: 18px;
}

.formFields__eFwud {
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}

.modalFooter__xNleO {
  margin-top: 15px;
  padding: 0 51px 25px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/CreateEditGpsTrackerModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;;AA4EA;EACE,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,OAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,+BAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAzEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.createGpsTrackerModal {\n  width: 372px;\n  height: 532px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.modalBody {\n  padding: 25px 51px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n}\n\n.modalBodyTitle {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 20px;\n  text-align: center;\n  text-transform: uppercase;\n  letter-spacing: 0.25px;\n  color: var(--header-title-main);\n  margin-bottom: 18px;\n}\n\n.formFields {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  row-gap: 5px;\n}\n\n.modalFooter {\n  margin-top: 15px;\n  padding: 0 51px 25px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"createGpsTrackerModal": `createGpsTrackerModal__xGNA_`,
	"modalBody": `modalBody__Papqc`,
	"modalBodyTitle": `modalBodyTitle__kzIJj`,
	"formFields": `formFields__eFwud`,
	"modalFooter": `modalFooter__xNleO`
};
module.exports = ___CSS_LOADER_EXPORT___;
